<template>
  <vue-modal :key="refreshModal" :ref="modalId" :name="modalId" :clickToClose="false" :draggable="true" :scrollable="true" :adaptive="true"  @opened="loadData" :resizable="false" :width="modalWidth" :minHeight="500" :maxHeight="550" :height="'auto'">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ modalTitle }}</h5>
        <button type="button" class="close" @click="closeModal">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container">
            <div class="">
                <div class="form-row form-group form-inline">
                  <label for="surveyId" class="col-2 mr-3">Survey</label>
                  <span class="w-75">{{ inputSurvey.surveyName }}</span>
                </div>
                <div class="form-row form-group form-inline">
                    <label for="group" class="col-2 mr-3">*Group</label>
                    <select id="group" name="group" class="w-50 custom-select required" v-model="surveyGroupId">
                        <option value="0">Select Group</option>
                        <option v-for="(option, idxSurveyGroupOptions) in surveyGroupSurveyList" 
                                v-bind:value="option.surveyGroupId" v-bind:key="idxSurveyGroupOptions">
                        {{ option.name }}
                        </option>
                    </select>
                </div>
            </div>                
        </div>
        <div :class="isError ? 'form-group form-row text-danger' : 'form-group form-row text-success'">
            {{ modalReturnMessage }}
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary ml-4" @click="copyValuePlayers" :disabled="disableCopy">Copy Value Ontology
            <span class="ml-auto">
              <font-awesome-icon :icon="['fa', 'copy']" />
            </span>
        </button>
        <button type="button" class="btn btn-primary ml-4" @click="closeModal">Close</button>
      </div>
    </div>
  </vue-modal>
</template>

<script>
import AdminService from "../services/admin.service";
import ViewMixins from "../mixins/ViewMixins.vue";
import SurveyGroupService from "../services/survey.group.service";
import ValuePlayerService from "../services/value.player.service";

export default {
  name: "CopyValuePlayers",
  mixins: [ViewMixins],
  components: {},
  data() {
    return {
      modalReturnMessage: "",
      isError: false,
      disableCopy: true,
      refreshModal: true,
      mode: "copy-survey-group",
      surveyGroupSurveyList: [],
      surveyGroupId: 0,
      processingComplete: false
    };
  },
  computed: {},
  mounted() {},
  created() {},
  methods: {
    async loadData(){
        this.modalReturnMessage = "";
        SurveyGroupService.getAllSurveyGroups(this.getAllSurveyGroupsCallback, this);
    },
    closeModal(){
      this.modalReturnMessage = "";
      if (this.$refs[this.modalId] != null) {
        this.$refs[this.modalId].visible = false;
      }
      this.refreshModal = !this.refreshModal;
    },   
    getAllSurveyGroupsCallback: function(response) {
      this.$root.processServerResponse();
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.surveyGroupSurveyList = response.data.data;
      }
    }, 
    copyValuePlayers: function(){
        this.processingComplete = false;
        const timer = setTimeout(() => {
          if (this.processingComplete == false || this.processingComplete == "false") {
            this.processingComplete = true;
            let message = "Processing is taking longer than usual. You will receive an email when the process completes.";
            AdminService.displayInfoMessage({ text: message, duration: -1 });
            this.modalReturnMessage = message;
            this.$parent.setModalLoading(false);
            this.$root.setLoading(false);
          }
        }, 60000);      

        let sourceSurveyCode = this.inputSurvey.surveyCode;
        let targetSurveyGroupId =  this.surveyGroupId; 
        ValuePlayerService.copyValuePlayers(sourceSurveyCode, targetSurveyGroupId, this.copyValuePlayersCallback, this);
    },
    copyValuePlayersCallback: function(response) {
        if (this.processingComplete == false || this.processingComplete == "false") {
          this.processingComplete = true;
          this.$root.processServerResponse();
          let statusCode = response.data.statusCode;
          let returnResponseMessage = response.data.message;
          if (statusCode == 200) {
              this.isError = false;
              //AdminService.displaySuccessMessage({ text: returnResponseMessage });
          } else {
              this.isError = true;
              //AdminService.displayErrorMessage({ text: returnResponseMessage });
          }
          this.modalReturnMessage = returnResponseMessage;
        }      

    },
  },
  watch: {
    surveyGroupId() {
        if(this.surveyGroupId == 0) {
            this.disableCopy = true;
        } else{
            this.disableCopy = false;
        }
    }
  },
  props: {
    inputSurvey: {
      type: Object,
      default: function () {
        return {};
      },
    },
    modalId: {
      type: String,
      default: "copy-value-players",
    },
    modalTitle: {
      type: String,
      default: "Copy Value Ontology",
    },
    modalWidth: {
      type: Number,
      default: 368,
    },
  }
};
</script>
